import ThemeProvider from './theme-provider-controller'

export default ThemeProvider
